import { render, staticRenderFns } from "./ContentCenterTwo.vue?vue&type=template&id=cb0f2684&scoped=true&"
import script from "./ContentCenterTwo.vue?vue&type=script&lang=js&"
export * from "./ContentCenterTwo.vue?vue&type=script&lang=js&"
import style0 from "./ContentCenterTwo.vue?vue&type=style&index=0&id=cb0f2684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0f2684",
  null
  
)

export default component.exports